import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/billing/invoices/page.tsx")